import React from 'react';
import { string, number, bool, func } from 'prop-types';

export default function PageView({ pageLinkClassName, pageClassName, selected, page, activeClassName, onClick }) {
    const pageClass = selected ? `${pageClassName} ${activeClassName}` : pageClassName;
    const url = `${window.location.href.split('?')[0]}?currentPage=${page}`;

    return (
        <li className={pageClass}>
            <a href={url} onClick={onClick} className={pageLinkClassName}>
                {page}
            </a>
        </li>
    );
}

PageView.propTypes = {
    page: number,
    pageLinkClassName: string,
    pageClassName: string,
    activeClassName: string,
    selected: bool,
    onClick: func
};

PageView.defaultProps = {
    page: 0,
    pageLinkClassName: '',
    pageClassName: '',
    activeClassName: '',
    selected: 0,
    onClick: () => {}
};
